import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable, of, Subject } from 'rxjs';
import { User } from '../models/user'
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { utility } from '../common/utility';
import { catchError } from 'rxjs/operators';
import { UserService } from './UserService';
import { AppFooterComponent } from '../app.footer.component';

@Injectable({
  providedIn: 'root'
})
export class AccountService {   
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;
    baseUrl: string;
    _userService: any;
    private appFooterGetAgreementsSubject: any;
    public appFooterGetAgreementsObservable: any;

    constructor(private router: Router, private http: HttpClient, private userService: UserService) {
        this.userSubject = new BehaviorSubject<User>(null);
        this.user = this.userSubject.asObservable();
        this._userService = userService;

        this.appFooterGetAgreementsSubject = new Subject<any>();
        this.appFooterGetAgreementsObservable = this.appFooterGetAgreementsSubject.asObservable();    
    }

    public callAppFooterGetAgreements() {
        this.appFooterGetAgreementsSubject.next(this.userValue);
    }

    public get userValue(): User {
        // if (this.userSubject.value == null)
        //     this.router.navigate(['/login']);
        return this.userSubject.value;
    }

    public LogIn(user, returnURL:any) {
      //  localStorage.setItem("user", JSON.stringify(user));
        this.userSubject.next(user);
        this.router.navigate([returnURL]);
        this.callAppFooterGetAgreements();
    }   

    public LogOut() {
        localStorage.removeItem('user');
        this.userSubject.next(null);
        this.router.navigate(['/login']);
    }

    public isLoggedIn() {
        var result = false;
        if (this.userSubject.value != null) {
            result = true;
        }
        return result;
    }

    public RemoveLoggedInUser() {
        localStorage.removeItem('user');
        localStorage.removeItem('authToken');
        this.userSubject.next(null);
    }

    public GetCurrentUser(): Observable<any> {
        this.baseUrl = environment.apiBase.concat("account/GetCurrentUser");
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetCurrentUser', [])));
    }

    public get IsAdmin() {
        var result = false;
        if (this.userSubject.value.broker.AspNetRoles != null && this.userSubject.value.broker.AspNetRoles.length > 0) {
            var roles = this.userSubject.value.broker.AspNetRoles;
            result = roles.indexOf('admin') > -1;
        }
        return result;
    }

    public get IsOfficeManager() {
        var result = false;
        if (this.userSubject.value.broker.AspNetRoles != null && this.userSubject.value.broker.AspNetRoles.length > 0) {
            var roles = this.userSubject.value.broker.AspNetRoles;
            result = roles.indexOf('officemanager') > -1;
        }
        return result;
    }

    public get IsAdminOrIsOfficeManager() {
        var result = false;
        if (this.IsAdmin || this.IsOfficeManager) {
            result = true;
        }            
        return result;
    }

    public  CanShowMenuItem()
    {
        var result = false;
        if(this.userSubject.value.broker != null)
        {
            if (this.IsAdmin || this.IsOfficeManager) {
                result = true;
            }
        }            
        return result;
    }

    public get HasEditownprofilePermission() {
        var result = false;
        if (this.userSubject.value.broker.AspNetRoles != null && this.userSubject.value.broker.AspNetRoles.length > 0) {
            var roles = this.userSubject.value.broker.AspNetRoles;
            result = roles.indexOf('editownprofile') > -1;
        }
        return result;
    }

    public CanUpdateSendingBroker() {
        var result = false;
        if (this.IsAdmin || this.IsOfficeManager) {
            result = true;
        }            
        return result;
    }

    public CanEditDeleteDealNote() {
        return this.IsAdmin;
    }

    public CanDeleteDealCommunicationUser() {
        return this.IsAdmin;
    }

    public CanEditDeal(ProposingUserID, ProposingManagerID, ReceivingUserID, ReceivingManagerID, proposingMemberID, receivingMemberID) {
        var result = false;
        if (this.IsAdmin ||
            this.userSubject.value.broker.Id == ProposingUserID ||
            this.userSubject.value.broker.Id == ProposingManagerID ||
            this.userSubject.value.broker.Id == ReceivingUserID ||
            this.userSubject.value.broker.Id == ReceivingManagerID) {
            result = true;
        }
        if(result == false)
        {
            if(this.CanEditMember(proposingMemberID) || this.CanEditMember(receivingMemberID))
            {
                result = true; 
            }
        }

        return result;
    }

    public CanAddNews(){
        return this.IsAdmin;
    }
    public CanDeleteNews() {
        return this.IsAdmin;
    }

    public CanDeleteMessage(postingUserId) {
        var result = false;
        if (this.IsAdmin) {
            return true;
        }
        if (this.userSubject.value.broker.Id == postingUserId) {
            result = true;
        }
        return result;
    }
    public CanActivateUser (profileId)
    {
        var result = false;
        if (this.IsAdmin) {
            return true;
        }
        else if (this.IsOfficeManager) {
            if (profileId == null) {
                result = true;
            } else {
                var pid = parseInt(profileId);
                result = this.userSubject.value.broker.EditableUsers.includes(pid);
            }           
        }
        return result;
    }
   
    public CanDesignateOfficeManager()
    {
        return this.IsAdmin;
    }
    public CanDesignateAdmin()
    {
        return this.IsAdmin;
    }   


    public CanEditProfile(profileId: number | null): Observable<boolean> {
    if (this.IsAdmin) {
        return of(true); // Admins always have access
    }

    if (this.IsOfficeManager) {
        if (profileId === null) {
            return of(true); // Office managers can edit if no specific profile is provided
        } else {
            const pid = parseInt(profileId.toString(), 10);
            return this.userService.CanEditUser(this.userSubject.value.broker.Id, pid)
                .pipe(
                    catchError(() => of(false)) // Ensure errors return false instead of failing
                );
        }
    }

    if (this.userSubject.value.broker.Id === profileId && this.HasEditownprofilePermission) {
        return of(true); // Allow users to edit their own profiles if they have permission
    }

    return of(false); // Default case: no permission
}


    public CanAddResource() {
        return this.IsAdmin;
    }
    public CanEditResource() {
        return this.IsAdmin;
    }
    public CanDeleteResource() {
        return this.IsAdmin;
    }

    public CanAddMember(){
        return this.IsAdmin;
    }
    public CanSearchInactive()
    {
        return this.IsAdmin;
    }
    public CanEditMemberTerritory()
    {
         return this.IsAdmin;
    }
    public CanAddUser(){
        return this.IsAdminOrIsOfficeManager;
    }
    public CanEditMember(memberId) {
        var result = false;
       
        if (this.IsAdmin) {
            return true;
        }
        if (this.IsOfficeManager) {
            if (memberId == null) {
                result = true;
            } else {
                var mid = parseInt(memberId);
                result = this.userSubject.value.broker.EditableMembers.includes(mid);
            }
        } 
        return result;
    }

    public CanViewEditResourceCategory() {
        return this.IsAdmin;
    }

}

